module.exports = __webpack_public_path__ + "img/forbes.53239ca6.svg";